import React, { Component } from 'react';
import Cart from "../headerComponents/cartLokal"
import cart from "../images/lokal/cart.png"
import cart1 from "../images/lokal/cart1.png"
import mracart from "../images/lokal/cartBtn.png"
import cartFragrance from "../fragrance/images/cartFragrance.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
export default class HeaderCart extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cartVisible: false
        };
        this.cartClick = this.cartClick.bind(this);
    }
    cartClick() {
        if (document.getElementById("globalSearchDiv") !== null) {
            document.getElementById("globalSearchDiv").style.display = "none";
        }
        if (!this.state.cartVisible) {
            document.addEventListener('click', this.cartOutsideClick, false);
        } else {
            document.removeEventListener('click', this.cartOutsideClick, false);
        }
        this.setState(prevState => ({
            cartVisible: !prevState.cartVisible,
        }));
    }
    cartOutsideClick(e) {
        if (this.cartNode) {
            if (this.cartNode.contains(e.target)) {
                return;
            }
            this.cartClick();
        }
    }
    render() {
        let themeId = localStorage.getItem('themeId')
        let isHeaderIconHide = '0'
        var siteUrlHeader = window.location.href;
        if (siteUrlHeader.indexOf("OrderSummary") !== -1 || siteUrlHeader.indexOf("viewOrder") !== -1) {
            isHeaderIconHide = '1'
        }
        let cartLength = 0;
        if (localStorage.getItem('selectedCartProduct') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectedCartProduct')).length);
        }
        if (localStorage.getItem('selectRestaurantCart') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectRestaurantCart')).length);
        }
        if (localStorage.getItem('selectCommonItemCart') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectCommonItemCart')).length);
        }
        return (
            (isHeaderIconHide === '0') ?
                <div className="headerIcons" ref={cartNode => { this.cartNode = cartNode; }}>
                    {(() => {
                        if (themeId === '36') {
                            return (
                                <span className="headerImage headerCartBtn" onClick={this.cartClick} title="Cart">
                                    <FontAwesomeIcon icon={faShoppingCart} />Cart<span className="cartCount" id="cartCount">{cartLength}</span>
                                </span>
                            )
                        }
                        if (themeId === '37' || themeId === '38' || themeId === '35' || themeId === '32') {
                            return (
                                <span className="headerImage" onClick={this.cartClick} title="Cart">
                                    <FontAwesomeIcon icon={faShoppingCart} /><span className="cartCount" id="cartCount">{cartLength}</span>
                                </span>
                            )
                        }
                        else if (themeId === '31') {
                            return (
                                <span className="headerImage" onClick={this.cartClick} title="Cart">
                                    <img src={cart1} alt="" /><span className="cartCount" id="cartCount">{cartLength}</span>
                                </span>
                            )
                        }
                        else if (themeId === '30') {
                            return (
                                <span className="headerImage" onClick={this.cartClick} title="Cart">
                                    <img src={cartFragrance} alt="" /><span className="cartCount" id="cartCount">{cartLength}</span>
                                </span>
                            )
                        }
                        else if (themeId === '29') {
                            return (
                                <span className="headerImage" onClick={this.cartClick} title="Cart">
                                    <img src={mracart} alt="" /><span className="cartCount" id="cartCount">{cartLength}</span>
                                </span>
                            )
                        }
                        else if (themeId === '28') {
                            return (
                                <span className="headerImage" onClick={this.cartClick} title="Cart">
                                    <span className="cartCount" id="cartCount">{cartLength}</span>
                                </span>
                            )
                        }
                        else if (themeId !== '' && themeId !== 'null' && themeId !== null) {
                            return (
                                <span className="headerImage" onClick={this.cartClick} title="Cart">
                                    <img src={cart} alt="" /><span className="cartCount" id="cartCount">{cartLength}</span>
                                </span>
                            )
                        }
                        else {
                            return (
                                <span className="headerImage headerCartBtn" onClick={this.cartClick} title="Cart">
                                    <FontAwesomeIcon icon={faShoppingCart} /><span className="cartCount" id="cartCount">{cartLength}</span>
                                </span>
                            )
                        }
                    })()}
                    {this.state.cartVisible && (
                        <div className="cartDiv">
                            <Cart cartClick={this.cartClick}></Cart>
                        </div>
                    )}
                </div>
                : ''
        )
    }
}